import { connect } from "react-redux";
import { getAutocompleteCustomer, getDetailCustomer } from "actions/Customer";
import { getListPhiKhac } from "actions/PhiKhac";
import { getListPhiKhacHangKy } from "actions/PhiKhacHangKy";
import { getComboNguonKhachHang } from "actions/NguonKhachHang";
import {
  postTinChap,
  setEnableEditCustomer,
  setChoVayEdit,
  checkEditCustomer,
} from "actions/ThemMoiTinChap";
import ThemMoiTinChap from "components/BaoCao/HopDongChoDuyet/ChucNang/Sua/SuaTinChap/ModalSuaTinChap";
import { getDetailCustomerSuccess } from "actions/Customer";

const mapStateToProps = (state) => ({
  customer: state.customer,
  user: state.user,
  phikhac: state.phikhac,
  phikhachangky: state.phikhachangky,
  loaitaisan: state.loaitaisan,
  thuoctinhtaisan: state.thuoctinhtaisan,
  store: state.store,
  nguonkhachhang: state.nguonkhachhang,
  camdo: state.camdo,
  cauhinh: state.cauhinh,
  taisan: state.taisan,
  themmoitinchap: state.themmoitinchap,
  phanquyen: state.phanquyen,
  quanlycuahang: state.quanlycuahang,
});

const mapDispatchToProps = (dispatch) => ({
  getAutocompleteCustomer: (dataSearch) =>
    dispatch(getAutocompleteCustomer(dataSearch)),
  getListPhiKhac: (dataSearch) => dispatch(getListPhiKhac(dataSearch)),
  getListPhiKhacHangKy: (dataSearch) => dispatch(getListPhiKhacHangKy(dataSearch)),
  getComboNguonKhachHang: () => dispatch(getComboNguonKhachHang()),
  postTinChap: (dataPost) => dispatch(postTinChap(dataPost)),
  getDetailCustomer: (dataSearch) => dispatch(getDetailCustomer(dataSearch)),
  setChoVayEdit: (data) => dispatch(setChoVayEdit(data)),
  checkEditCustomer: (data) => dispatch(checkEditCustomer(data)),
  setEnableEditCustomer: (data) => dispatch(setEnableEditCustomer(data)),
  getDetailCustomerSuccess: (data) => dispatch(getDetailCustomerSuccess(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ThemMoiTinChap);
